export const ADD_MARKER = "ADD_MARKER";
export const REMOVE_MARKER = "REMOVE_MARKER";
export const CHANGE_POSITION_NEW_MARKER = "CHANGE_POSITION_NEW_MARKER";
export const CHANGE_NAME_NEW_MARKER = "CHANGE_NAME_NEW_MARKER";
